var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('header', {
    staticClass: "sm:container mx-8 sm:mx-auto"
  }, [_c('p', {
    staticClass: "mb-4 text-subnav sm:text-subhead uppercase"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('h1', {
    staticClass: "w-3/4 sm:w-full text-h2 sm:text-h1"
  }, [_vm._t("subtitle")], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }